import React from 'react';
import SafeIcon from '../../../common/SafeIcon';

const ManagerTeam = () => {
  const team = [
    { id: 1, name: "Sarah Jenkins", role: "Support Worker", status: "Compliant", lastActive: "12 Mar 2026", color: "text-green-600", bg: "bg-green-100" },
    { id: 2, name: "James Cole", role: "Senior Carer", status: "1 Module", lastActive: "10 Mar 2026", color: "text-amber-600", bg: "bg-amber-100" },
    { id: 3, name: "Aisha Patel", role: "Support Worker", status: "2+ Modules", lastActive: "01 Feb 2026", color: "text-red-600", bg: "bg-red-100" },
    { id: 4, name: "Mark Davies", role: "Team Leader", status: "Compliant", lastActive: "13 Mar 2026", color: "text-green-600", bg: "bg-green-100" },
  ];

  return (
    <div className="max-w-6xl mx-auto">
      <header className="mb-8">
        <h1 className="text-3xl font-serif font-bold text-navy-900">Team Overview</h1>
        <p className="text-slate-500 mt-2">Manage your staff records and training progress.</p>
      </header>

      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
        <div className="p-6 border-b border-slate-200 bg-slate-50 flex justify-between items-center">
          <h3 className="font-bold text-navy-900">Staff Members ({team.length})</h3>
          <div className="relative">
            <SafeIcon name="Search" className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
            <input type="text" placeholder="Search staff..." className="pl-9 pr-4 py-2 text-sm border border-slate-200 rounded-lg outline-none focus:border-navy-900" />
          </div>
        </div>
        
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead className="bg-white border-b border-slate-200">
              <tr>
                <th className="p-4 font-semibold text-slate-600">Staff Member</th>
                <th className="p-4 font-semibold text-slate-600">Role</th>
                <th className="p-4 font-semibold text-slate-600">Compliance Status</th>
                <th className="p-4 font-semibold text-slate-600">Last Active</th>
                <th className="p-4 font-semibold text-slate-600 text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {team.map((member) => (
                <tr key={member.id} className="hover:bg-slate-50 transition-colors">
                  <td className="p-4">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center font-bold text-navy-900 text-xs">
                        {member.name.split(' ').map(n => n[0]).join('')}
                      </div>
                      <span className="font-bold text-navy-900">{member.name}</span>
                    </div>
                  </td>
                  <td className="p-4 text-slate-600">{member.role}</td>
                  <td className="p-4">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${member.bg} ${member.color}`}>
                      {member.status}
                    </span>
                  </td>
                  <td className="p-4 text-slate-500">{member.lastActive}</td>
                  <td className="p-4 text-right">
                    <button className="text-navy-600 hover:text-navy-900 font-medium text-xs border border-navy-200 px-3 py-1.5 rounded hover:bg-slate-50">
                      View Full Record
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ManagerTeam;